import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/PageHeader";
import HowItWorksButton from "../../../components/howItWorks/HowItWorksButton";
import Contract from "../../contract/Contract";

const SettingsContacts = ({ token, API }) => {
  const { t } = useTranslation();

  return (
    <div className="settings-page-wrapper">
      <PageHeader
        title={t("Collection Contacts")}
        showBackButton={true}
        backRoute="/settings"
        backLabel={t("Back to Settings")}
        helpButton={<HowItWorksButton topic="collectionContacts" />}
      />
      <div className="settings-content-wrapper">
        <div className="settings-list-shell">
          <Contract token={token} API={API} />
        </div>
      </div>
    </div>
  );
};

export default SettingsContacts;
